import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/userservice/api/dict/list',
    method: 'post',
    data: data
  });
}
export function fetchListByType(dicType) {
  var data = {
    dicType: dicType
  };
  return request({
    url: '/userservice/api/dict/list',
    method: 'post',
    data: data
  });
}
export function fetchDetail(queryData) {
  return request({
    url: '/userservice/api/dict/detail',
    method: 'post',
    queryData: queryData
  });
}
export function fetchDelete(dicIds) {
  var data = {
    dicIds: dicIds
  };
  return request({
    url: '/userservice/api/dict/delete',
    method: 'post',
    data: data
  });
}
export function fetchLinkageTree() {
  return request({
    url: '/userservice/api/dict/getDicLinkageList',
    method: 'post'
  });
}
export function fetchCreate(data) {
  return request({
    url: '/userservice/api/dict/create',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/userservice/api/dict/update',
    method: 'post',
    data: data
  });
}